import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { IFormFieldsValidationModel } from '../../../../models/form-fields-formly-validation.model';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  datePickerFieldParseIntoSettingsFormModel,
  datePickerFieldUpdateFromSettingsFormModel,
  defaultInputConfigFormModel,
  getExtendedDateFieldSettingsConfigFormly,
} from '../custom-datepicker-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';
import { EIremboFormlyValidationTypes } from '@irembo-andela/irembogov3-common';
import { ValidationTypeDefaultMessage } from '../../form-builder-validation-type-message.utils';

export class CustomDatePickerFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultInputConfigFormModel;
    this.settingsFormlyForm = [
      ...getExtendedDateFieldSettingsConfigFormly(this.formBuilderService),
    ];
    this.validationsFormlyModel = {
      required: false,
      minDateConfig: {
        minDateType: 'none',
        relativeMinDateValue: '',
        relativeMinDateUnit: 'd',
      },
      maxDateConfig: {
        maxDateType: 'none',
        relativeMaxDateValue: '',
        relativeMaxDateUnit: 'd',
      },
      allowedDaysOfTheWeek: {},
      validationMessages: {},
    };
    this.availableValidations.push(
      'idConditions',
      'minDateConfig',
      'maxDateConfig',
      'allowedDaysOfTheWeek'
    );
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return datePickerFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    return datePickerFieldUpdateFromSettingsFormModel(model, this.field);
  }

  override parseFieldConfigIntoValidationsFormModel(): IFormFieldsValidationModel {
    const model = super.parseFieldConfigIntoValidationsFormModel();
    const ageLimit = this.field.props?.['idConditions']?.['ageLimit'];
    const hasAgeLimit =
      ageLimit && (ageLimit.minimumAge || ageLimit.maximumAge);

    if (!hasAgeLimit || model.validations?.['idConditions']) {
      return model;
    }

    return {
      ...model,
      validations: {
        ...(model.validations || {}),
        idConditions: {
          logics: [
            {
              idConditions: {
                ageLimit: {
                  key: ageLimit.key ?? ageLimit.dateFieldKey ?? 'dateOfBirth',
                  minimumAge: ageLimit.minimumAge,
                  maximumAge: ageLimit.maximumAge,
                },
              },
              errorMessages: {
                [EIremboFormlyValidationTypes.minimumAge]: String(
                  this.field.validation?.messages?.[
                    EIremboFormlyValidationTypes.minimumAge
                  ] ??
                    ValidationTypeDefaultMessage(
                      EIremboFormlyValidationTypes.minimumAge
                    )
                ),
                [EIremboFormlyValidationTypes.maximumAge]: String(
                  this.field.validation?.messages?.[
                    EIremboFormlyValidationTypes.maximumAge
                  ] ??
                    ValidationTypeDefaultMessage(
                      EIremboFormlyValidationTypes.maximumAge
                    )
                ),
              },
            },
          ],
        },
      },
    };
  }
}
